import React from 'react';

import classes from './Burger.css';
import BurgerIngredient from './BurgerIngredient/BurgerIngredient';

const burger = ( props ) => {
    let transformedIngredients = Object.keys( props.ingredients )
        .map( igKey => {
            return [...Array( props.ingredients[igKey] )].map( ( _, i ) => {
                return <BurgerIngredient key={igKey + i} type={igKey} />;
            } );
        } )
        .reduce((arr, el) => {
            return arr.concat(el)
        }, []);
    if (transformedIngredients.length === 0) {
        transformedIngredients = (
        <div>
            <h3>Coffee Cart Privacy Policy</h3>
            <p><span>App Creators:</span> KJ Garrett & Conner Erickson</p>
            <p><span>Data Collection:</span> All data is created and destroyed by the user of the application.
                Data is stored on a database similar to the one hosting this site (firebase). We, the application 
                creators do not store any data/insights about the user. There are no accounts, just a singular access
                code given to the contractors of the application.
            </p>
            <p>Future versions of this application, if instructed to do so by the contractor, may implement
                potential data gathering on number of orders created and to whom they are created to for better user
                insights. But currently, data is stored on the database and deleted by the admininstrators of the application.
            </p>
            <p><span>Volunteer Work:</span> As of now, this application is strictly an undergraduate volunteer project for the public Bainbridge High School
                in Seattle, WA.
            </p>
            <p>We, the app builders, are in ongoing communication with the department who is working along side of us to create an experience 
                best fit for their needs. If any changes may arise in the privacy policy, they will be the ones instructing those chagnes.
            </p>
            <p><span>Date:</span> February 25, 2019</p>
        </div>);
    }
    return (
        <div className={classes.Burger}>
            <BurgerIngredient type="bread-top" />
            {transformedIngredients}
            <BurgerIngredient type="bread-bottom" />
        </div>
    );
};

export default burger;